import "./Navbar.css";
import { BRAND_NAME, BRAND_ACCENT } from "../../constants/brand";
import { auth } from "../../config";
import { useLocation } from "react-router";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  //Signout
  const SignOut = () => {
    signOut(auth)
      .then(() => {})
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    const links = [
      { url: "/dashboard", id: "dashboard" },
      { url: "/cards", id: "cards" },
      { url: "/transactions", id: "transactions" },
    ];
    links.forEach((link) => {
      const el = document.getElementById(link.id);
      if (!el) return;
      if (location.pathname === link.url) {
        el.classList.add("activeLink");
      } else {
        el.classList.remove("activeLink");
      }
    });
  }, [location.pathname]);

  return (
    <div className="navWrapper">
      <div className="Logo">
        <h2>
          {BRAND_NAME}<span className="logo-accent">{BRAND_ACCENT}</span>
        </h2>
      </div>

      {loggedIn && (
        <>
          <div className="Links">
            <a href="dashboard" className="navLinks" id="dashboard">
              Dashboard
            </a>
            <a href="transactions" className="navLinks" id="transactions">
              Transactions
            </a>
            <a href="cards" className="navLinks" id="cards">
              Cards
            </a>

            <a href="/" id="link" className="navLinks" onClick={SignOut}>
              Logout
            </a>
          </div>

          <div className="mobileMenu">
            {!isOpen ? (
              <div className="isOpenImages">
                <FontAwesomeIcon
                  icon={faBars}
                  style={{ color: "white", fontSize: "1.5rem" }}
                  onClick={() => setIsOpen(true)}
                />
              </div>
            ) : (
              <>
                <div className="isOpenImages">
                  <FontAwesomeIcon
                    icon={faXmark}
                    style={{ color: "white", fontSize: "1.5rem" }}
                    onClick={() => setIsOpen(false)}
                  />
                </div>

                <div className="mobileMenuItems">
                  <a href="dashboard" className="navLinks" id="dashboard">
                    Dashboard
                  </a>
                  <a href="transactions" className="navLinks" id="transactions">
                    Transactions
                  </a>
                  <a href="cards" className="navLinks" id="cards">
                    Cards
                  </a>

                  <a href="/" id="link" className="navLinks" onClick={SignOut}>
                    Logout
                  </a>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Navbar;
